import { initializeMsalInstance } from "libs/msal";
import { isSupportedBrowser } from "libs/support";

initializeMsalInstance();

if (isSupportedBrowser()) {
	import("./application.jsx");
} else {
	import("./unsupported.jsx");
}
